import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Users } from "lucide-react";
import { StatsCard } from "./StatsCard";
import { useNavigate } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";

export const UserManagement = () => {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const gymId = profile?.gym_id;

  const { data: userCount } = useQuery({
    queryKey: ["userCount"],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("profiles")
        .select("*", { count: "exact", head: true });

      if (error) throw error;
      return count;
    },
  });

  const usersUrl = gymId ? `/total-usuarios?gym_id=${gymId}` : "/total-usuarios";

  return (
    <div onClick={() => navigate(usersUrl)} className="cursor-pointer">
      <StatsCard
        title="Total Usuarios"
        value={userCount || 0}
        description="Click para ver detalles"
        icon={Users}
      />
    </div>
  );
};